import { defineStore } from "pinia"
import { useUserStore } from './user'
import centersApi from "@/services/api/settings/centers/centers"

const getDefaultState = () => ({
  resourcesItems: [],
  calendarEvents: null,
  resourcesFiltered: [],
  eventStored: null,
  groupEventsStored: [],
  calendarSettings: null,
  // JSON crudo tal cual lo devuelve GET /calendar/settings. Se guarda la primera
  // vez que lo pide Calendar.vue para que otros componentes (CalendarView.vue,
  // modales, etc.) puedan leer cualquier SETTINGS_* sin volver a pegar al endpoint.
  rawCalendarSettings: null,
  whatsAppInstances: null,
  _whatsAppInstancesInflight: null,
  addDurationToServicesInAppointment: 1,
  centersItems: [],
  showPaymentColorMode: false,
  centerFiltered: [], 
  selectedResources:[],
  viewMode:1,
  cutAppointmentsStored: null,
});

export const useSchedulerStore = defineStore("scheduler", {
  state: getDefaultState,
  
  persist: {
    key: 'scheduler',
    paths: ['resourcesFiltered', 'centerFiltered'],
    
    storage: {
      getItem: (key) => {
        const userStore = useUserStore();
        const userId = userStore.profile?.id;
        const customerCode = userStore.profile?.customer_code;
        if (!userId || !customerCode) return null;
        
        const userKey = `${key}_${customerCode}_${userId}`;
        return localStorage.getItem(userKey);
      },
      setItem: (key, value) => {
        const userStore = useUserStore();
        const userId = userStore.profile?.id;
        const customerCode = userStore.profile?.customer_code;
        if (!userId || !customerCode) return;
        
        const userKey = `${key}_${customerCode}_${userId}`;
        localStorage.setItem(userKey, value);
      },
      removeItem: (key) => {
        const userStore = useUserStore();
        const userId = userStore.profile?.id;
        const customerCode = userStore.profile?.customer_code;
        if (!userId || !customerCode) return;
        
        const userKey = `${key}_${customerCode}_${userId}`;
        localStorage.removeItem(userKey);
      }
    }
  },
  
  actions: {
    setSelectedResources(resources){
      this.selectedResources = resources
    },
    setCentersItems(centersItems) {
      this.centersItems = centersItems;
    },

    setResourcesItems(resourcesItems) {
      this.resourcesItems = resourcesItems;
    },

    setResourcesSelected(resourcesFiltered) {
      this.resourcesFiltered = resourcesFiltered;
    },

    setCentersSelected(centerFiltered) {
      this.centerFiltered = centerFiltered;
    },

    setCalendarEvents(calendarEvents) {
      this.calendarEvents = calendarEvents;
    },

    setAddDurationToServicesInAppointment(addDuration){
      this.addDurationToServicesInAppointment = addDuration
    },
    setWhatsAppInstances(wsInstances) {
      this.whatsAppInstances = wsInstances;
    },

    // Lazy loader: antes se pedia al arranque en AuthenticatedLayout aunque
    // la mayoria de sesiones nunca abren un modal de WhatsApp. Ahora solo se
    // carga la primera vez que se consulta desde algun consumidor (modales
    // de recordatorios, encuestas, historiales, etc.).
    async ensureWhatsAppInstances() {
      if (this.whatsAppInstances !== null) return this.whatsAppInstances;
      if (this._whatsAppInstancesInflight) return this._whatsAppInstancesInflight;
      this._whatsAppInstancesInflight = centersApi.getAllWhatsAppInstances()
        .then(res => {
          this.setWhatsAppInstances(res.data);
          return this.whatsAppInstances;
        })
        .catch(err => {
          console.error('Error cargando whatsAppInstances (lazy):', err);
          return null;
        })
        .finally(() => { this._whatsAppInstancesInflight = null; });
      return this._whatsAppInstancesInflight;
    },

    setEvent(event) {
      this.eventStored = event;
    },

    setCalendarSettings(calendarSettings){
      this.calendarSettings = calendarSettings
    },

    setRawCalendarSettings(rawCalendarSettings) {
      this.rawCalendarSettings = rawCalendarSettings
    },

    setCutAppointments(data) {
      this.cutAppointmentsStored = data;
    },

    clearCutAppointments() {
      this.cutAppointmentsStored = null;
    },

    togglePaymentColorMode() {
      this.showPaymentColorMode = !this.showPaymentColorMode;
    },
  
    setPaymentColorMode(value) {
      this.showPaymentColorMode = value;
    },

    setSophiaSettings(SophiaSettings) {
      this.SophiaSettings = SophiaSettings
    },
    
    setLogout() {
      const userStore = useUserStore();
      const userId = userStore.profile?.id;
      const customerCode = userStore.profile?.customer_code;
      
      // Borrar explícitamente del localStorage
      if (userId && customerCode) {
        localStorage.removeItem(`scheduler_${customerCode}_${userId}`);
      }
      
      this.$reset();
    },

    clearResourcesCache() {
      // Limpiar solo los arrays en memoria
      // La persistencia de Pinia actualizará el localStorage automáticamente
      this.resourcesFiltered = [];
      this.centerFiltered = [];
    }

  },
  getters: {
    getEventStored: (state) => state.eventStored,
    getResourcesItems: (state) => state.resourcesItems,
    getCentersItems: (state) => state.centersItems,
    getcalendarEvents: (state) => state.calendarEvents,
    getWhatsAppInstances: (state) => state.whatsAppInstances,
    isPaymentColorModeActive: (state) => state.showPaymentColorMode,
    getCutAppointments: (state) => state.cutAppointmentsStored,
  },
});
